module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/glow-bottom.d4656426.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/glow-bottom.png
// module id = 3059
// module chunks = 11